var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "id": "topbar-post-login",
      "color": "transparent",
      "dark": "",
      "dense": "",
      "fixed": "",
      "prominent": ""
    }
  }, [_c('div', {
    staticClass: "mt-7"
  }, [_c('span', [_vm._v("SECRETARIA DE EDUCAÇÃO E ESPORTES")])]), _c('v-spacer'), _c('v-toolbar-title', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "app-icon",
    attrs: {
      "src": "https://cdn.educacao.pe.gov.br/storage/assets/logo_SEE_psh_G02_B_png_779d0caae9.png",
      "alt": "brasão-home-64px"
    }
  })])])], 1), _c('div', {
    attrs: {
      "id": "background-image-wrapper"
    }
  }, [_c('vue-page-transition', {
    staticStyle: {
      "margin-top": "8%"
    },
    attrs: {
      "name": "fade-in-right"
    }
  }, [_c('router-view', {
    staticClass: "page"
  })], 1)], 1), _c('v-main', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "logo-wrapper mt-7"
  }, [_c('img', {
    staticClass: "app-icon-logo",
    attrs: {
      "src": "/img/logo_sigofoco_colorido.png",
      "alt": "brasão-home-64px"
    }
  }), _c('div', {
    staticClass: "welcome-text mt-7"
  }, [_c('small', [_vm._v(" Seja bem vindo(a) ao Sistema de "), _c('br'), _vm._v(" Gestão da Formação Continuada! ")])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }